module.exports = __webpack_public_path__ + "img/social/twitter-2.6517b36.png";